import { useId, useState } from 'react';
import { MarkdownContent } from '@backstage/core-components';
import { waadooIcons } from '../ui/icons/waadooIcons';

export const DETAILS_TOGGLE = 'En savoir plus';

const ExpandIcon = waadooIcons.expand;

/**
 * « En savoir plus »: a small text button under the subtitle, aligned with
 * the title, and the details in a light neutral box under it once opened. A
 * native button (Enter and Space) with `aria-expanded` and `aria-controls`;
 * the closed box is `hidden`, out of the accessibility tree.
 */
export function DetailsToggle(props: { details: string }) {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  return (
    <>
      <button
        type="button"
        className="waadoo-sf-toggle"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen(current => !current)}
      >
        {DETAILS_TOGGLE}
        <ExpandIcon
          className="waadoo-sf-toggle__chevron"
          aria-hidden
          focusable="false"
        />
      </button>
      <div id={panelId} className="waadoo-sf-section__details" hidden={!open}>
        <MarkdownContent content={props.details} linkTarget="_blank" />
      </div>
    </>
  );
}
